import React, { useState, useEffect } from 'react';
import "./quiz-app.css";

function QuizApp({questionProp, optionsProp, answerProp, triggerAvatarCorrect, triggerAvatarIncorrect}) {
  const [selectedOption, setSelectedOption] = useState("");
  const [feedback, setFeedback] = useState("");
  const [options, setOptions] = useState([""]);
  const [question, setQuestion] = useState("");
  const [correctAnswer, setCorrectAnswer] = useState("");

  function cleanOptions(options) {
    return options.map(option => option.replace(/^\[+|\]+$/g, ''));
  }  
  
  useEffect(() => {   
    setCorrectAnswer(answerProp);  
  }, [answerProp]);

  useEffect(() => {   
    setQuestion(questionProp);  
  }, [questionProp]);

  useEffect(() => {  
    const cleanedOptions = cleanOptions(optionsProp); 
    setOptions(cleanedOptions);  
  }, [optionsProp]);

  const handleSubmit = () => {
    if (!selectedOption) {
      setFeedback({ message: "Please select an option.", type: "wrong" });
      return;
    }
    console.log(correctAnswer);
    console.log(selectedOption);
    if (selectedOption.trim() === correctAnswer.trim()) {
      setFeedback({ message: "✓  Correct! Well done.", type: "correct" });
      triggerAvatarCorrect();
    } else {
      setFeedback({ message: "✗  Incorrect. Try again.", type: "wrong" });
      triggerAvatarIncorrect();
    }
  };

  return (
    <div className="quiz-container">
      <div className="question">{question}</div>
      <div className="options">
        {options.map((option) => (
          <label key={option} className="option-label">
            <input
              type="radio"
              name="option"
              value={option}
              onChange={(e) => setSelectedOption(e.target.value)}
              className="option-input"
            />
            {` ${option}`}
          </label>
        ))}
      </div>
      <button className="submit-btn" onClick={handleSubmit}>Submit</button>
      {feedback && (
        <div className="feedback" style={{
          color: feedback.type === "correct" ? "rgba(72,199,142,1)" : "rgba(252,129,129,1)",
          background: feedback.type === "correct" ? "rgba(72,199,142,0.12)" : "rgba(252,129,129,0.12)",
          border: `1px solid ${feedback.type === "correct" ? "rgba(72,199,142,0.3)" : "rgba(252,129,129,0.3)"}`,
        }}>
          {feedback.message}
        </div>
      )}
    </div>
  );
}

export default QuizApp;

